$(function () {
  const $window　=　$(window);
  const breakpoint = 768;

  // 見出し部分のスタイル調整
  function setHeading() {
    const $heading = $('.js-heading');
    const $headingTxt = $('.js-heading-txt');

    $window.on('load resize', function () {
      const windowWidth = $window.width();
      const isDeviceSp = windowWidth < breakpoint;

      if (isDeviceSp) {
        const headingTxtHeight = $headingTxt.outerHeight();
        $heading.css({'margin-bottom': headingTxtHeight});
      } else {
        $heading.css({'margin-bottom': ''});
      }
    });
  }

  // ショップ表示
  function initShop() {
    let urlParam = location.search.substring(1);
    let urlAreaCategory = urlParam.split('paginate=');
  
    if(urlParam) {
      getAPI('initParm',urlAreaCategory[0],1)
      setCheckBox(getParam());
    } else {
      getAPI('init','area=1,2,3,4&category=1,2',1)
    }
  }

  // チェックボックスをセットし直す
  function setCheckBox(checkItems) {
    const checkArea = checkItems[0]
    const checkCategory = checkItems[1]

    $('.js-area input').prop('checked', false)
    $('.js-category input').prop('checked', false)

    if (checkArea) {
      for (let i = 0; i < checkArea.length; i++) {
        $(".js-area input[value='"+ checkArea[i] + "']").prop('checked', true);
      }
    }

    if (checkCategory) {
      for (let i = 0; i < checkCategory.length; i++) {
        $(".js-category input[value='"+ checkCategory[i] + "']").prop('checked', true);
      }
    }
  }

  // パラメータ取得
  function getParam() {
    let urlParam = location.search.substring(1);
    let urlAreaCategory = urlParam.split('paginate=');
  
    if (1 < document.location.search.length) {
      const parameters = urlAreaCategory[0].split('&');
      let areaParm;
      let catParm;

      if(parameters[0].length) {
        const areaElement = parameters[0].split('=');
        areaParm = areaElement[1];
        if (areaElement[1] && areaElement[1].length > 2) {
          areaParm = areaElement[1].split(',');
        }
      }

      if(parameters[0].length) {
        const catElement = parameters[1].split('=');
        catParm = catElement[1];
        if(catElement[1] && catElement[1].length > 2) {
          catParm = catElement[1].split(',');
        }
      }

      return [areaParm,catParm];
    }
    return null;
  }

  // 履歴の移動処理
  window.addEventListener('popstate',function(event) {
    if(event.state) {
      const parm = event.target.location.search.slice(1);

      setCheckBox(getParam())
      getAPI('back', parm, 1)
    }
  });
  
  // APIを取得
  function getAPI(state, parmStr, paginate) {
    const $shopTotal = $('.js-shopList-total')
    const $shopList = $('.js-shopList-list')
    const $shopItem = $('.js-shopList-list .js-shopList-item')

    $.ajax({
      type: 'GET',
      url: '/syokunotaishikan/api/stores?' + parmStr + 'paginate='  + paginate,
      dataType: 'json',
      beforeSend: function () {
        if(state === 'search') {
          $('.js-shopList-list .js-shopList-item').remove();
          $('.js-shopList-btn').remove();
        }
        $('.js-loading').addClass('is-active');
      }
    })
    .done(function(data) {
      if(data.success === false ){
        $shopTotal.text('0');
        $('.noItems').addClass('is-active')
        $('.js-loading').removeClass('is-active');
        return
      }

      const shopHTML = createShopDOM(data);

      switch (state) {
        case 'init':
          $shopTotal.text(data.total);
          $shopList.append(shopHTML);
          setMoreBtn(data.total);
          break;

        case 'initParm':
          $shopTotal.text(data.total);
          $shopItem.remove();
          $shopList.append(shopHTML);
          history.pushState("state", null, "syokunotaishikan?" + parmStr + 'paginate=' + '1');  
          setMoreBtn(data.total);
          break;

        case 'search':
          $shopTotal.text(data.total);
          $shopItem.remove();
          $shopList.append(shopHTML);
          $("title").text('えひめ食の大使館｜えひめ愛フード推進機構');
          history.pushState("state", null, "syokunotaishikan?" + parmStr + 'paginate=' + paginate);
          setMoreBtn(data.total);
          break;

        case 'paginate':
          $shopList.append(shopHTML);
          $("title").text('えひめ食の大使館｜えひめ愛フード推進機構');
          history.pushState("state", null, "syokunotaishikan?" + parmStr + 'paginate=' + paginate);
          setMoreBtn(data.total);
          break;

        case 'back':
          $("title").text('えひめ食の大使館｜えひめ愛フード推進機構');
          setMoreBtn(data.total);
          break;
  
        default:
      }
      $('.noItems').removeClass('is-active')
      $('.js-loading').removeClass('is-active');
    })
    .fail(function(){
      console.log('エラー')
    })
  }

  // 店舗一覧DOMを生成
  function createShopDOM(data) {
    let arrayHtml=[];
     
   let html;
   for (let i = 0; i<data.stores.length; i++) {
    let id = data.stores[i].id;
    let name = data.stores[i].name;
    let area = data.stores[i].area;
    let category = data.stores[i].category;
    let image = data.stores[i].image;
    html = `
      <li class="shopList__item mod-shopList__item js-shopList-item">
        <a href="/syokunotaishikan/detail/` + id + `" class="shopList__link mod-shopList__link">
          <p class="shopList__img mod-shopList__img"><img src="` + image + `" alt="` + name + `"></p>
          <dl class="shopList__desc mod-shopList__desc">
            <dt class="shopList__term mod-shopList__team">` + name + `</dt>
            <dd class="shopList__dfn mod-shopList__dfn">
              <div class="shopList__categories mod-shopList__categories mod-categories">
                <p class="shopList__category mod-shopList__category mod-shopList__category--type mod-category mod-category--type01">` + category + `</p>
                <p class="shopList__category mod-shopList__category mod-shopList__category--area mod-category mod-category--area02">` + area + `</p>
              </div>
            </dd>
          </dl>
        </a>
      </li>
    `
      arrayHtml.push(html);
    }
    return arrayHtml;
  }

  // チェックボックスを取得する
  function getCheckbox() {
    let areaArray = [];
    let categoryArray = [];
    $('.js-area input:checked').each(function(){
      areaArray.push($(this).val());
    })
    $('.js-category input:checked').each(function(){
      categoryArray.push($(this).val());
    })

    let parmStr = '';
    if (areaArray.length > 0) {
      parmStr = 'area=' + areaArray.join(',') + '&';
    }

    if (categoryArray.length > 0) {
      parmStr = parmStr + 'category=' + categoryArray.join(',') + '&';
    }
    return parmStr;
  }

  // 絞り込む
  function searchShop() {
    $('.js-submit-btn').on('click', function(e) {
      e.preventDefault();
      $('.result .mod-inner .item').remove();
      const parmStr = getCheckbox();

      getAPI('search',parmStr, 1);
    });
  }

  // もっと見るボタン
  function setMoreBtn(shopTotal) {
    if($('.js-shopList-item').length === shopTotal || shopTotal < 10) {
      $('.js-shopList-btn').remove();
      return;
    } else if(!$('.js-shopList-btn').length) {
      const html = `
      <p class="shopList__btn js-shopList-btn" data-paginate="1">
      <button type="button">さらに表示</button>
      </p>
      `
      $('.shopList__body').after(html);
    }
  }

  // ページネーション処理
  function paginate() {
    $(document).on("click", ".js-shopList-btn", function(e){
      e.preventDefault();

      const parmStr = getCheckbox();
      let num = $('.js-shopList-btn').data('paginate') + 1;
      getAPI('paginate',parmStr, num);
      $('.js-shopList-btn').data('paginate',num)
    });
  }

  const isPageTop = $('#top').length;
  if (isPageTop) {
    initShop();
    searchShop();
    paginate();
    setHeading();
  }
});